<template>
    <div class="echartsRadar">
        <div class="echartsRadarIn" ref="echartsRadarIn"></div>
        <div class="echartsRadarNum" v-if="!echartClick">
            <div class="echartsRadarNumFen">{{ runAverage }}</div>
            <div class="echartsRadarNumName">综合得分</div>
        </div>
    </div>
</template>

<script>

import * as echarts from 'echarts';

export default {
    name: "echartsRadar",
    data() {
        return {
            echartData: null,
            echartArrayData: null,
            echartPartArrayData: null,
            indicatorList: [
                { name: '肘部角度', min: -50, max: 100 },
                { name: '脚落地', min: -50, max: 100 },
                { name: '脚提起', min: -50, max: 100 },
                { name: '摆臂偏移量', min: -50, max: 100 },
                { name: '蹬伸摆动', min: -50, max: 100 },
                { name: '摆臂幅度', min: -50, max: 100 }
            ],
            runAverage: null,
            echartClick: false,
            clickedIndex: null,
        }
    },
    props: {
        initData: Object,
    },
    watch: {
        initData: {
            handler(val) {
                console.log('echart雷达图=', val)
                if (val) {
                    this.echartData = val.echartData;
                    this.echartClick = val.echartClick;
                    this.echartArrayData = [
                        this.echartData['elbow_status'].toFixed(0) * 1,
                        this.echartData['initial_concat_stage'].toFixed(0) * 1,
                        this.echartData['midstance_stage'].toFixed(0) * 1,
                        this.echartData['no_elbow_forward_no_hand_backward_principle'].toFixed(0) * 1,
                        this.echartData['push_off_stage'].toFixed(0) * 1,
                        this.echartData['swinging_arm_status'].toFixed(0) * 1,
                    ]
                    this.echartPartArrayData = [
                        'elbow_status',
                        'initial_concat_stage',
                        'midstance_stage',
                        'no_elbow_forward_no_hand_backward_principle',
                        'push_off_stage',
                        'swinging_arm_status',
                    ]
                    this.computeAverage()
                    setTimeout(() => {
                        this.drawEchart();
                    }, 100)
                }
            },
            immediate: true
        },
    },
    mounted() {
        // this.drawEchart();
    },
    methods: {
        changeSel(index) {
            this.clickedIndex = index;
            this.myChart.setOption(this.option);
        },
        computeAverage() {
            const nonZeroNumbers = this.echartArrayData.filter(num => num !== 0);
            if (nonZeroNumbers.length === 0) {
                return 0;
            }
            const sum = nonZeroNumbers.reduce((acc, num) => acc + num, 0);
            // console.log('sum=', sum)
            this.runAverage = (sum / nonZeroNumbers.length).toFixed(0);
        },
        drawEchart() {
            // let that = this;
            var chartDom = this.$refs.echartsRadarIn;
            var myChart = echarts.init(chartDom);
            this.myChart = myChart;

            let bgcColor = null;
            if (this.echartClick) {
                bgcColor = {
                    color: 'rgba(146,177,246,0.57)' // 设置背景色，这里使用浅蓝色并带有一定透明度
                }
            }
            var option;
            option = {
                grid: {
                    left: '0%',  // 距离容器左侧的距离
                    right: '0%', // 距离容器右侧的距离
                    top: '0%',   // 距离容器顶部的距离
                    bottom: '0%' // 距离容器底部的距离
                },
                radar: {
                    shape: 'circle',
                    center: ['50%', '50%'],
                    radius: '75%',
                    startAngle: 60,
                    indicator: this.indicatorList,
                    axisName: {
                        show: false,
                        formatter: function (value) {
                            // console.log(value, index)
                            return `{value|${value}}`;
                        },
                        rich: {
                            value: {
                                color: 'rgba(107,107,134,1)',
                                fontSize: this.remToPx(0.62)
                            },
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            color: [
                                '#fff',
                                '#fff',
                                'rgba(209, 231, 241, 1)',
                                'rgba(209, 231, 241, 1)',
                                'rgba(209, 231, 241, 1)',
                                'rgba(209, 231, 241, 1)',
                                'rgba(209, 231, 241, 1)',
                            ],
                        },
                    },
                    // 坐标轴轴线
                    axisLine: {
                        lineStyle: {
                            color: 'rgba(209, 231, 241, 1)'
                        }
                    },
                    splitArea: {
                        areaStyle: {
                            color: ['#fff'],
                        }
                    },
                },
                series: [
                    {
                        name: 'Budget vs spending',
                        type: 'radar',
                        data: [
                            {
                                value: this.echartArrayData,
                                name: 'Allocated Budget',
                                areaStyle: bgcColor
                            },
                        ],
                        label: {
                            show: true,
                            formatter: params => {
                                let mark = params.value;
                                if (params.value == 0) {
                                    mark = '???';
                                }
                                if (params.dimensionIndex == this.clickedIndex) {
                                    let valueAc = 'valueAc' + params.dimensionIndex;
                                    let extraAc = 'extraAc' + params.dimensionIndex;
                                    return `{${valueAc}|${mark}分} \n{${extraAc}|${this.indicatorList[params.dimensionIndex].name}}`;
                                }
                                else {
                                    let value = 'value' + params.dimensionIndex;
                                    let extra = 'extra' + params.dimensionIndex;
                                    return `{${value}|${mark}分} \n{${extra}|${this.indicatorList[params.dimensionIndex].name}}`;
                                }
                            },
                            rich: {
                                value0: {
                                    color: '#2F2F50',
                                    fontSize: this.remToPx(0.6),
                                },
                                extra0: {
                                    color: '#6B6B86',
                                    fontSize: this.remToPx(0.4),
                                },
                                valueAc0: {
                                    color: '#5663DF',
                                    fontSize: this.remToPx(0.8),
                                    fontWeight: 'bold'
                                },
                                extraAc0: {
                                    color: '#638FF4',
                                    fontSize: this.remToPx(0.6),
                                    fontWeight: 'bold'
                                },
                                value1: {
                                    color: '#2F2F51',
                                    fontSize: this.remToPx(0.6),
                                },
                                extra1: {
                                    color: '#6B6B86',
                                    fontSize: this.remToPx(0.4),
                                },
                                valueAc1: {
                                    color: '#5663DF',
                                    fontSize: this.remToPx(0.8),
                                    fontWeight: 'bold'
                                },
                                extraAc1: {
                                    color: '#638FF4',
                                    fontSize: this.remToPx(0.6),
                                    fontWeight: 'bold'
                                },
                                value2: {
                                    color: '#2F2F52',
                                    fontSize: this.remToPx(0.6),
                                    padding: [0, 50, -20, 0],
                                },
                                extra2: {
                                    color: '#6B6B86',
                                    fontSize: this.remToPx(0.4),
                                    padding: [0, 50, -30, 0],
                                },
                                valueAc2: {
                                    color: '#5663DF',
                                    fontSize: this.remToPx(0.8),
                                    fontWeight: 'bold',
                                    padding: [0, 50, -20, 0],
                                },
                                extraAc2: {
                                    color: '#638FF4',
                                    fontSize: this.remToPx(0.6),
                                    fontWeight: 'bold',
                                    padding: [0, 50, -40, 0],
                                },
                                value3: {
                                    color: '#2F2F53',
                                    fontSize: this.remToPx(0.6),
                                    padding: [0, 0, -60, 0]
                                },
                                extra3: {
                                    color: '#6B6B86',
                                    fontSize: this.remToPx(0.4),
                                    padding: [0, 0, -70, 0]
                                },
                                valueAc3: {
                                    color: '#5663DF',
                                    fontSize: this.remToPx(0.8),
                                    fontWeight: 'bold',
                                    padding: [0, 0, -60, 0]
                                },
                                extraAc3: {
                                    color: '#638FF4',
                                    fontSize: this.remToPx(0.6),
                                    fontWeight: 'bold',
                                    padding: [0, 0, -80, 0]
                                },
                                value4: {
                                    color: '#2F2F54',
                                    fontSize: this.remToPx(0.6),
                                    padding: [0, 0, -60, 0]
                                },
                                extra4: {
                                    color: '#6B6B86',
                                    fontSize: this.remToPx(0.4),
                                    padding: [0, 0, -70, 0]
                                },
                                valueAc4: {
                                    color: '#5663DF',
                                    fontSize: this.remToPx(0.8),
                                    fontWeight: 'bold',
                                    padding: [0, 0, -60, 0]
                                },
                                extraAc4: {
                                    color: '#638FF4',
                                    fontSize: this.remToPx(0.6),
                                    fontWeight: 'bold',
                                    padding: [0, 0, -80, 0]
                                },
                                value5: {
                                    color: '#2F2F55',
                                    fontSize: this.remToPx(0.6),
                                    padding: [0, 0, -20, 50]
                                },
                                extra5: {
                                    color: '#6B6B86',
                                    fontSize: this.remToPx(0.4),
                                    padding: [0, 0, -30, 50]
                                },
                                valueAc5: {
                                    color: '#5663DF',
                                    fontSize: this.remToPx(0.8),
                                    fontWeight: 'bold',
                                    padding: [0, 0, -20, 60]
                                },
                                extraAc5: {
                                    color: '#638FF4',
                                    fontSize: this.remToPx(0.6),
                                    fontWeight: 'bold',
                                    padding: [0, 0, -40, 60]
                                },
                            },
                            position: 'top'
                        },
                        lineStyle: {
                            color: '#6581F3',
                            width: this.remToPx(0.13),
                        },
                        itemStyle: {
                            color: '#6F62F4'
                        },
                    }
                ]
            };
            this.option = option;

            option && myChart.setOption(option);

            if (this.echartClick) {
                myChart.on('click', (params) => {
                    if (params.componentType === 'series' && params.seriesType === 'radar') {
                        if (params.dataIndex !== undefined && 'text' in params.event.target.style) {
                            let text = params.event.target.style.text;
                            let index = null;
                            if (text.indexOf('分') == -1) {
                                index = this.indicatorList.findIndex(item => item.name == text);
                            }
                            else {
                                index = params.event.target.style.fill.slice(-1) * 1
                            }
                            if (index >= 0 && index <= 5 && index != this.clickedIndex) {
                                this.clickedIndex = index;
                                myChart.setOption(option);
                                this.$emit('selectIndex', index);
                            }
                        }
                    }
                });
            }
        },
        remToPx(rem) {
            // 假设你想要设置的折线宽度为 0.2rem
            const lineWidthInRem = rem;
            // 获取根元素的字体大小，根元素字体大小决定了 1rem 的值
            const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
            // 将 rem 转换为 px
            const lineWidthInPx = lineWidthInRem * rootFontSize;
            // console.log(lineWidthInPx)
            return lineWidthInPx
        }
    }
}
</script>

<style scoped>
.echartsRadar {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: relative;
}

.echartsRadarIn {
    width: 100%;
    height: 100%;
}

.echartsRadarNum {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.echartsRadarNumFen {
    font-size: 1.74rem;
    font-family: Myriad Pro, Myriad Pro-Regular;
    font-weight: 400;
    text-align: center;
    color: #474ad9;
    line-height: 2.18rem;
    letter-spacing: 0.01rem;
}

.echartsRadarNumName {
    font-size: 0.72rem;
    font-family: Adobe Heiti Std, Adobe Heiti Std-R;
    font-weight: normal;
    text-align: left;
    color: #2f2f51;
    line-height: 1.03rem;
}
</style>